import React from 'react';
import {
  VictoryLine,
  VictoryChart,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryLabel,
  VictoryArea
} from 'victory';
import './Charts.css';

// Custom theme matching your dark mode design
const customTheme = {
  chart: {
    padding: { top: 40, bottom: 50, left: 60, right: 40 }
  },
  axis: {
    style: {
      axis: {
        stroke: '#64748b'
      },
      grid: {
        stroke: 'rgba(100, 116, 139, 0.1)'
      },
      tickLabels: {
        fill: '#94a3b8',
        fontSize: 10
      }
    }
  }
};

const LineChart = ({ data = [], title = 'Visitor Traffic', xAxis = 'Time', yAxis = 'Visitors' }) => {
  // Ensure we have data and format it properly
  const formattedData = data.map(point => ({
    x: new Date(point.timestamp),
    y: point.value
  }));

  return (
    <div className="chart-container">
      <h3>{title}</h3>
      <div className="chart-wrapper">
        <VictoryChart
          theme={customTheme}
          width={600}
          height={300}
          scale={{ x: "time" }}
          padding={{ top: 20, bottom: 40, left: 60, right: 30 }}
          containerComponent={
            <VictoryVoronoiContainer
              labels={({ datum }) => 
                `${datum.y} visitors\n${datum.x.toLocaleDateString()}`
              }
              labelComponent={
                <VictoryTooltip
                  style={{ fontSize: 10, fill: '#fff' }}
                  flyoutStyle={{
                    stroke: 'none',
                    fill: 'rgba(0, 0, 0, 0.8)'
                  }}
                />
              }
            />
          }
          animate={{
            duration: 2000,
            onLoad: { duration: 1000 }
          }}
        >
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#10b981" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
            </linearGradient>
          </defs>

          <VictoryAxis
            tickFormat={(t) => new Date(t).toLocaleDateString()}
            label={xAxis}
            axisLabelComponent={<VictoryLabel dy={25} style={{ fill: '#94a3b8' }} />}
          />
          
          <VictoryAxis
            dependentAxis
            label={yAxis}
            axisLabelComponent={<VictoryLabel dx={-40} style={{ fill: '#94a3b8' }} />}
          />

          <VictoryArea
            data={formattedData}
            style={{
              data: {
                fill: 'url(#gradient)',
                stroke: 'none'
              }
            }}
            interpolation="monotoneX"
          />

          <VictoryLine
            data={formattedData}
            style={{
              data: {
                stroke: '#10b981',
                strokeWidth: 2
              }
            }}
            interpolation="monotoneX"
          />
        </VictoryChart>
      </div>
    </div>
  );
};

export default LineChart; 